export const getters = {
    layout (state) {
        return state.currentLayout
    },

    patient (state) {
        return state.patient
    },

    patientPosition (state) {
        return state.patientPosition
    },

    patientPlace (state) {
        return state.patientPlace
    },

    patientPlaceName (state) {
        return state.patientPlaceName
    },

    patientMedicalPractice (state) {
        return state.patientMedicalPractice
    },

    online (state) {
        return state.online
    },

    getOnboardingStep (state) {
        return state.onboardingStep
    },

    getCurrentOffice (state) {
        return state.currentOffice
    },

    getCurrentDate (state) {
        return state.currentDate
    },

    getUserId (state) {
        return state.userId
    },

    getFirebaseToken (state) {
        return state.firebaseToken
    },

    getListenAppointments (state) {
        return state.listenAppointments
    },

    getDoctor (state) {
        return state.doctor
    },

    getOffices (state) {
        return state.offices
    },

    getRecommendations (state) {
        return state.offices
    },

    getNotifications (state) {
        return state.notifications
    },

    getLanguages (state) {
        return state.languages
    },

    getCountries (state) {
        return state.countries
    },

    getDefaultCountryId (state) {
        return state.defaultCountryId
    },

    getError (state) {
        return state.error
    }
}



// WEBPACK FOOTER //
// ./src/store/getters.js